export default {"src":"/_next/static/image/public/images/ic_package_blue_vertical_menu.0d5c0b9bd81b9979c9e621c54240ff97.svg","height":20,"width":20};